import { lazy, Suspense } from 'react';
import KeralaEvents from './pages/KeralaEvents';
import './App.css';

const AdminPortal = lazy(() => import('./pages/AdminPortal'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Terms = lazy(() => import('./pages/Terms'));
const Contact = lazy(() => import('./pages/Contact'));

const routes = { '/admin': AdminPortal, '/privacy': Privacy, '/terms': Terms, '/contact': Contact };

function App() {
  const Page = routes[window.location.pathname];
  if (Page) return <Suspense fallback={null}><Page /></Suspense>;
  return <KeralaEvents />;
}

export default App;
